import { getValue } from "@utils/lodash";
import React from "react";
import Input from "../Forms/Input";
import {
  formHandleBooleanArrayChange,
  formHandleDateArrayChange,
  formHandleLookeupArrayChange,
  formHandleNumericArrayChange,
  formHandleTextAreaArrayChange,
  formHandleTextArrayChange,
  formHandleTimeArrayChange,
} from "@common/handleChange";
import DateMonthYearPicker from "../Forms/Date";
import TextArea from "../Forms/textarea";
import { capitalizeFirstLetter } from "@common/text-helpers";
import TimePicker from "../Forms/Time";
import "./form-builder.scss";
import Radio from "../Forms/Radio";
import Checkbox from "../Forms/Checkbox";
import { generateFieldOptions } from "./generate-options";
import SingleSelectSearchDropdown from "../CustomSearchableDropdown/SingleSelectSearchDropdown";
import { getLookUpIdByName } from "./request-helper";
import MultiSelectDropdown from "../CustomSearchableDropdown/multi/index2";
import { attachRolesInUser, dettachRolesInUser } from "@services/roles.service";
import { toast } from "react-toastify";

function FormBuilder(props: any) {
  const {
    setFields,
    fields,
    simpleValidator,
    formOptions,
    mainInfo,
    expense_report_id,
    reportList,
    default_currency,
  } = props;
  
  const getMinDate = (name: string) => {
    let duration_from =
      getValue(fields, `length`, 0) > 0
        ? fields.filter(
            (item: object) =>
              getValue(item, `field_name`, "") === "duration_from"
          )
        : [];
    const reportData =
      getValue(reportList, `length`, 0) > 0
        ? reportList.find((item: any) => item.id === expense_report_id)
        : null;
    switch (name) {
      case "duration_to":
        return getValue(duration_from, `[${0}].field_value`, "")
          ? new Date(getValue(duration_from, `[${0}].field_value`, ""))
          : null;
      case "expense_date":
      case "expense_end_date":
      case "expense_start_date":
        return getValue(reportData, `duration_from`, "")
          ? new Date(getValue(reportData, `duration_from`, ""))
          : null;
      default:
        return null;
    }
  };

    const handleId = async (id: string, field_name: string, field_value: any) => {
      if (field_name === "roles" && id) {
        let filtered =
          getValue(field_value, `length`, 0) > 0 &&
          field_value.filter((item: string) => item === id);
        if (getValue(filtered, `length`, 0) === 0) {
          try {
            let resp = await attachRolesInUser(getValue(props, `id`, ""), {
              role_ids: [id],
            });
            if (resp) {
              toast.success("Attached successfully");
              props.getUserForms();
            }
          } catch (error) {}
        } else {
          try {
            let resp = await dettachRolesInUser(getValue(props, `id`, ""), id);
            if (resp) {
              toast.success("Removed successfully");
              props.getUserForms();
            }
          } catch (error) {}
        }
      }
    };
  
  const pushIntoArray = (id: string, item:any) => {
    let allIDs: any = [...getValue(item, `field_value`, "")];
    if (!allIDs.includes(id)) {
      if (getValue(item, `field_value`, "") === "") {
        allIDs = [id];
      } else {
        allIDs.push(id);
      }
      return allIDs;
    } else {
      let filtered = allIDs.filter((item: string) => item !== id);
      return filtered;
    }
  };

  const getMaxDate = (name: string) => {
    const reportData =
      getValue(reportList, `length`, 0) > 0
        ? reportList.find((item: any) => item.id === expense_report_id)
        : null;

    switch (name) {
      case "expense_date":
      case "expense_end_date":
      case "expense_start_date":
        return getValue(reportData, `duration_to`, "")
          ? new Date(getValue(reportData, `duration_to`, ""))
          : new Date();
      default:
        return new Date();
    }
  };

  const renderForm = (item: any, index: number, formOptions: any) => {
    const isReportName = getValue(item, `field_name`, "") === "report_name";

    switch (
      getValue(item, `data_type`, "") +
      "-" +
      getValue(item, `sub_data_type`, "")
    ) {
      case "text-single_line_text":
        return (
          <div className="form_builder_field">
            <Input
              {...item}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                formHandleTextArrayChange(index, e, setFields)
              }
              // value={getValue(item, `field_value`, "")}
              value={
                isReportName
                  ? "This field will be auto-generated"
                  : getValue(item, `field_value`, "")
              }
              type={"text"}
              placeholder={`Enter ${getValue(item, `display_name`, "")}`}
              // placeholder={isReportName ? "This Field will be auto generated" : `Enter ${getValue(item, `display_name`, "")}`}
              label={`${capitalizeFirstLetter(
                getValue(item, `display_name`, "")
              )}`}
              validator={
                getValue(item, `is_mandatory`, false) && simpleValidator
              }
              mandatory={
                isReportName ? false : getValue(item, `is_mandatory`, false)
              }
              disabled={isReportName} // Disable input if field name is "report_name"
              validatoryType="required"
              minLength={item?.min_length}
              maxLength={item?.max_length}
            />
          </div>
        );
      case "radio-boolean":
        return (
          <div className="form_builder_field">
            <Radio
              {...item}
              onChange={(e: any) =>
                formHandleBooleanArrayChange(
                  index,
                  e,
                  setFields,
                  getValue(item, `field_value`, "") === true ? false : true
                )
              }
              value={getValue(item, `field_value`, "")}
              checked={getValue(item, `field_value`, "") ? true : false}
              type={getValue(item, `data_type`, "")}
              placeholder={`Enter ${getValue(item, `display_name`, "")}`}
              label={`${capitalizeFirstLetter(
                getValue(item, `display_name`, "")
              )}`}
              validator={
                getValue(item, `is_mandatory`, false) && simpleValidator
              }
              mandatory={getValue(item, `is_mandatory`, false)}
            />
          </div>
        );
      case "checkbox-boolean":
      case "text-checkbox":
        return (
          <div className="form_builder_field">
            <Checkbox
              {...item}
              onChange={(e: any) =>
                formHandleBooleanArrayChange(
                  index,
                  e,
                  setFields,
                  getValue(item, `field_value`, "") === true ? false : true
                )
              }
              value={getValue(item, `field_value`, "")}
              checked={getValue(item, `field_value`, "") ? true : false}
              type="checkbox"
              placeholder={`Enter ${getValue(item, `display_name`, "")}`}
              label={`${capitalizeFirstLetter(
                getValue(item, `display_name`, "")
              )}`}
              validator={
                getValue(item, `is_mandatory`, false) && simpleValidator
              }
              mandatory={getValue(item, `is_mandatory`, false)}
            />
          </div>
        );
      case "text-multi_line_text":
        return (
          <div className="form_builder_field">
            <TextArea
              {...item}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                formHandleTextAreaArrayChange(index, e, setFields)
              }
              value={getValue(item, `field_value`, "")}
              type={"textarea"}
              label={`${getValue(item, `display_name`, "")}`}
              placeholder={`Enter ${getValue(item, `display_name`, "")}`}
              rows={5}
              validator={
                getValue(item, `is_mandatory`, false) && simpleValidator
              }
              mandatory={getValue(item, `is_mandatory`, false)}
              minLength={item?.min_length}
              maxLength={item?.max_length}
            />
          </div>
        );
      case "numerical-single_line_text":
        return (
          <div className="form_builder_field">
            <Input
              {...item}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                formHandleNumericArrayChange(index, e, setFields)
              }
              value={getValue(item, `field_value`, "")}
              type={"number"}
              placeholder={`Enter ${getValue(item, `display_name`, "")}`}
              label={`${getValue(item, `display_name`, "")}`}
              validator={
                getValue(item, `is_mandatory`, false) && simpleValidator
              }
              mandatory={getValue(item, `is_mandatory`, false)}
            />
          </div>
        );
      case "numerical-percentage":
        return (
          <div className="form_builder_field">
            <Input
              {...item}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                formHandleNumericArrayChange(index, e, setFields)
              }
              value={getValue(item, `field_value`, "")}
              type={"number"}
              placeholder={`Enter ${getValue(item, `display_name`, "")}`}
              label={`${getValue(item, `display_name`, "")}`}
              validator={
                getValue(item, `is_mandatory`, false) && simpleValidator
              }
              mandatory={getValue(item, `is_mandatory`, false)}
            />
          </div>
        );
      case "numerical-decimal":
        return (
          <div className="form_builder_field">
            <Input
              {...item}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                formHandleNumericArrayChange(index, e, setFields)
              }
              value={getValue(item, `field_value`, "")}
              type={"number"}
              placeholder={`Enter ${getValue(item, `display_name`, "")}`}
              label={`${getValue(item, `display_name`, "")}`}
              validator={
                getValue(item, `is_mandatory`, false) && simpleValidator
              }
              mandatory={getValue(item, `is_mandatory`, false)}
            />
          </div>
        );
      case "numerical-number":
        return (
          <div className="form_builder_field">
            <Input
              {...item}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                formHandleNumericArrayChange(index, e, setFields)
              }
              value={getValue(item, `field_value`, "")}
              type={"number"}
              placeholder={`Enter ${getValue(item, `display_name`, "")}`}
              label={`${getValue(item, `display_name`, "")}`}
              validator={
                getValue(item, `is_mandatory`, false) && simpleValidator
              }
              mandatory={getValue(item, `is_mandatory`, false)}
            />
          </div>
        );

      case "email-email":
        return (
          <div className="form_builder_field">
            <Input
              {...item}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                formHandleTextArrayChange(index, e, setFields)
              }
              value={getValue(item, `field_value`, "")}
              type={"email"}
              placeholder={`Enter ${getValue(item, `display_name`, "")}`}
              label={`${getValue(item, `display_name`, "")}`}
              validator={
                getValue(item, `is_mandatory`, false) && simpleValidator
              }
              validatoryType={
                getValue(item, `required`, false) && "required|email"
              }
              mandatory={getValue(item, `is_mandatory`, false)}
            />
          </div>
        );
      case "phone-phone":
        return (
          <div className="form_builder_field">
            <Input
              {...item}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                formHandleTextArrayChange(index, e, setFields)
              }
              type={"text"}
              placeholder={`Enter ${getValue(item, `display_name`, "")}`}
              label={`${getValue(item, `display_name`, "")}`}
              validator={
                getValue(item, `is_mandatory`, false) && simpleValidator
              }
              validatoryType={
                getValue(item, `required`, false) && "required|min:10|max:10"
              }
              mandatory={getValue(item, `is_mandatory`, false)}
            />
          </div>
        );
      case "url-url":
        return (
          <div className="form_builder_field">
            <Input
              {...item}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                formHandleTextArrayChange(index, e, setFields)
              }
              value={getValue(item, `field_value`, "")}
              type={"url"}
              placeholder={`Enter ${getValue(item, `display_name`, "")}`}
              label={`${getValue(item, `display_name`, "")}`}
              validator={
                getValue(item, `is_mandatory`, false) && simpleValidator
              }
              mandatory={getValue(item, `is_mandatory`, false)}
            />
          </div>
        );
      case "date-date":
        return (
          <div className="form_builder_field">
            <DateMonthYearPicker
              {...item}
              onChange={(e: any) =>
                formHandleDateArrayChange(index, e, setFields)
              }
              value={
                getValue(item, `field_value`, "")
                  ? getValue(item, `field_value`, "")
                  : null
              }
              type={"text"}
              label={`${getValue(item, `display_name`, "")}`}
              placeholder={`Enter ${getValue(item, `display_name`, "")}`}
              validator={
                getValue(item, `is_mandatory`, false) && simpleValidator
              }
              // minDate={new Date()}
              mandatory={getValue(item, `is_mandatory`, false)}
              maxDate={getMaxDate(getValue(item, `field_name`, ""))}
              minDate={getMinDate(getValue(item, `field_name`, ""))}
            />
          </div>
        );
      case "date-date_time":
        return (
          <div className="form_builder_field">
            <TimePicker
              {...item}
              onChange={(e: any) =>
                formHandleTimeArrayChange(index, e, setFields)
              }
              value={
                getValue(item, `field_value`, "")
                  ? getValue(item, `field_value`, "")
                  : null
              }
              type={"text"}
              label={`${getValue(item, `display_name`, "")}`}
              placeholder={`Enter ${getValue(item, `display_name`, "")}`}
              validator={
                getValue(item, `is_mandatory`, false) && simpleValidator
              }
              showTimeInput
              mandatory={getValue(item, `is_mandatory`, false)}
            />
          </div>
        );
      case "time-time":
      case "date-time":
      case "text-time":
        return (
          <div className="form_builder_field">
            <TimePicker
              {...item}
              onChange={(e: any) =>
                formHandleTimeArrayChange(index, e, setFields)
              }
              value={
                getValue(item, `field_value`, "")
                  ? getValue(item, `field_value`, "")
                  : null
              }
              type={"text"}
              label={`${getValue(item, `display_name`, "")}`}
              placeholder={`Enter ${getValue(item, `display_name`, "")}`}
              validator={
                getValue(item, `is_mandatory`, false) && simpleValidator
              }
              showTimeSelectOnly
              mandatory={getValue(item, `is_mandatory`, false)}
            />
          </div>
        );
      case "picklist-single_select":
        return (
          <div className="form_builder_field">
            <SingleSelectSearchDropdown
              {...item}
              placeholder={`Enter ${getValue(item, `display_name`, "")}`}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                formHandleLookeupArrayChange(index, e, setFields)
              }
              label={`label`}
              validator={
                getValue(item, `is_mandatory`, false) && simpleValidator
              }
              width={"100%"}
              default_currency={default_currency}
              data={
                getValue(item, `is_custom_field`, false)
                  ? findCustomFieldPicklist(getValue(item, `field_name`, ""))
                  : generateFieldOptions(
                      getValue(item, `field_name`, ""),
                      getValue(
                        formOptions,
                        `[${getValue(item, `field_name`, "")}]`,
                        []
                      ),
                      []
                    )
              }
              value={getValue(item, `field_value`, "")}
              selectKey={"id"}
              name={getValue(item, `display_name`, "")}
              mandatory={getValue(item, `is_mandatory`, false)}
              showLabel
            />
          </div>
        );
      
      case "picklist-multi_select":        
        return (
          <div className="form_builder_field">
          <MultiSelectDropdown
            {...item}
            placeholder={`Enter ${getValue(item, `display_name`, "")}`}
            onChange={(option: any) => {
                setFields((options: any[]) =>
                  options.map((x: any, i: number) => {
                    if (i !== index) return x;

                    const fieldValue = Array.isArray(x.field_value)
                      ? x.field_value
                      : [];

                    const exists = fieldValue.some(
                      (v: any) => v.id === option.id
                    );

                    return {
                      ...x,
                      field_value: exists
                        ? fieldValue.filter((v: any) => v.id !== option.id) // remove
                        : [...fieldValue, option],                          // add
                    };
                  })
                );
              }}
            label={`label`}
            validator={getValue(item, `is_mandatory`, false) && simpleValidator}
            width={"100%"}
            defaultOptions={
                getValue(item, `is_custom_field`, false)
                ? findCustomFieldPicklist(getValue(item, `field_name`, "")) : []
            }
            value={
              Array.isArray(getValue(item, "field_value",false))
                ? getValue(item, "field_value",false).map((v: any) =>
                    typeof v === "object" ? v.id : v
                  )
                : []
            }

            name={getValue(item, `display_name`, "")}
            mandatory={getValue(item, `is_mandatory`, false)}
            showLabel
          />
        </div>
        );

      case "lookup-single_select":
        return (
          <div className="form_builder_field">
            <SingleSelectSearchDropdown
              {...item}
              placeholder={`Enter ${getValue(item, `display_name`, "")}`}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                formHandleLookeupArrayChange(index, e, setFields)
              }
              lookup_id={getLookUpIdByName(item)}
              label={`label`}
              validator={
                getValue(item, `is_mandatory`, false) && simpleValidator
              }
              width={"100%"}
              default_currency={default_currency}
              value={getValue(item, `field_value`, "")}
              name={getValue(item, `display_name`, "")}
              lookup_api={getValue(item, `field_name`, "")}
              mandatory={getValue(item, `is_mandatory`, false)}
              showLabel
            />
          </div>
        );
      case "lookup-currency":
        return (
          <div className="form_builder_field">
            <SingleSelectSearchDropdown
              {...item}
              placeholder={`Enter ${getValue(item, `display_name`, "")}`}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                formHandleLookeupArrayChange(index, e, setFields)
              }
              label={`label`}
              validator={
                getValue(item, `is_mandatory`, false) && simpleValidator
              }
              width={"100%"}
              default_currency={default_currency}
              value={getValue(item, `field_value`, "")}
              name={getValue(item, `display_name`, "")}
              lookup_api={getValue(item, `field_name`, "")}
              mandatory={getValue(item, `is_mandatory`, false)}
              showLabel
            />
          </div>
        );
      default:
        return null;
    }
  };

  const findCustomFieldPicklist = (name: string) => {
    const data = getValue(mainInfo, `custom_list`, {});
    // Find key that includes "::custom_field_2"
    const targetKey = Object.keys(data).find((key) => key.endsWith(name));
    if (targetKey) {
      // Access the array if key is found
      const customFieldArray = data[targetKey];
      let array =
        getValue(customFieldArray, `length`, 0) > 0
          ? customFieldArray.map((item: object) => ({
              ...item,
              value: getValue(item, `id`, ""),
              label: getValue(item, `text`, ""),
            }))
          : [];
      return array;
    } else {
    }
  };
  return (
    <div>
      {getValue(fields, `length`, 0) > 0 &&
        fields.map((item: any, key: number) => {
          return (
            <div className={`form_wrapper-pipeline`} key={key}>
              {renderForm(item, key, formOptions)}
            </div>
          );
        })}
    </div>
  );
}

export default FormBuilder;
